import React from 'react';
import { MapPin, Phone, Mail, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 px-4 border-t border-slate-800" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-70">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-71">
            <div className="mb-6" data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/mLJdqn1YBuqHdE7DWNbtyp/pasted-image.webp" alt="A-Flow Seamless Rain Gutters" className="h-12 w-auto bg-white p-2 rounded-lg" data-id="element-73" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-74">
              Providing top-quality seamless aluminum and copper rain gutters
              for residential and commercial properties in Southern California.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-800 rounded-md text-sm font-medium text-slate-200 border border-slate-700" data-id="element-75">
              <ShieldCheck className="w-4 h-4 text-[#b87333]" data-id="element-76" />
              Licensed & Insured
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-77">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-78">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-79">
              {[{
              name: 'Home',
              href: '/'
            }, {
              name: 'About Us',
              href: '/about'
            }, {
              name: 'Services',
              href: '/services'
            }, {
              name: 'Appointment Request',
              href: '/appointment'
            }, {
              name: 'Contact Us',
              href: '/contact'
            }].map(link => <li key={link.name} data-id="element-80">
                  <Link to={link.href} className="text-slate-400 hover:text-[#b87333] transition-colors text-sm flex items-center gap-2" data-id="element-81">
                    <span className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-82" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-83">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-84">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-85">
              <li className="text-slate-400 text-sm" data-id="element-86">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-87">
                  Seamless Rain Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-88">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-89">
                  Copper Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-90">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-91">
                  Gutter Guards
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-92">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-93">
                  Gutter Repair
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-94">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-95">
                  Maintenance & Cleaning
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-96">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-97">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-98">
              <li className="flex items-start gap-3 text-sm text-slate-400" data-id="element-99">
                <MapPin className="w-5 h-5 text-[#b87333] shrink-0 mt-0.5" data-id="element-100" />
                <span data-id="element-101">
                  Orange County, CA
                  <br data-id="element-102" />
                  Serving Southern California
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-103">
                <Phone className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-104" />
                <a href="tel:7146023634" className="hover:text-white transition-colors" data-id="element-105">
                  (714) 602-3634
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-106">
                <Mail className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-107" />
                <a href="mailto:info@aflowraingutters.com" className="hover:text-white transition-colors" data-id="element-108">
                  info@aflowraingutters.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500" data-id="element-109">
          <p data-id="element-110">
            © {new Date().getFullYear()} A-Flow Seamless Rain Gutters. All
            rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-111">
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}